import { Box, CircularProgress, Collapse, Container } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useTypeEntity from '../../Manager/ManagerViewLocations/EntityBusinessLayerList/useTypeEntity';
import TitleIcon from '../../../../theme/ui/Atoms/TilteIcon';
import { ViewLocationIcon } from '../../../../assets';
import { SearchBar } from '../../../../theme/ui/Atoms/SearchBar/SearchBar';

interface LocationsLayoutProps {
  children: React.ReactNode;
  showRightPanel?: boolean;
  rightPanel?: React.ReactNode;
  innerContainerMaxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  onSearch: (item: any) => void;
  role: string;
}
function WorkspaceListLayout(props: LocationsLayoutProps) {
  const {
    children,
    innerContainerMaxWidth = 'lg',
    role = 'businessUnits',
    showRightPanel = false,
    rightPanel,
    onSearch,
  } = props;
  const { isLoading, groupId } = useTypeEntity();
  const { t } = useTranslation();
  return (
    <Box>
      <Container
        maxWidth="xl"
        style={{
          overflow: 'none',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            my: 4,
          }}
        >
          <Box flex={'2 1 auto'}>
            {!groupId && (
              <TitleIcon
                icon={
                  isLoading ? (
                    <CircularProgress size={'2em'} />
                  ) : (
                    <ViewLocationIcon height={'2em'} />
                  )
                }
              >
                {t('view_locations.view_all')} {t(`view_locations.${role}`)}
              </TitleIcon>
            )}
          </Box>
          <Box flex={'1 1 auto'}>
            <SearchBar selectItem={onSearch}>
              <SearchBar.MarketsSearch />
            </SearchBar>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
            mt: 4,
            overflow: 'hidden',
          }}
        >
          <Box
            className="transition-p"
            sx={[
              {
                transition: 'flex-basis 0.3s ease-in-out 0.225s',
                overflow: 'auto',
              },
              showRightPanel
                ? {
                    flex: '0 0 40%',
                  }
                : {
                    flex: '1 1 100%',
                  },
            ]}
          >
            <Container
              maxWidth={innerContainerMaxWidth}
              sx={{
                overflow: 'auto',
              }}
            >
              {children}
            </Container>
          </Box>

          <Collapse
            orientation="horizontal"
            in={showRightPanel}
            mountOnEnter
            unmountOnExit
          >
            <Box
              sx={{
                flex: '0 0 60%',
                overflow: 'auto',
              }}
            >
              {rightPanel}
            </Box>
          </Collapse>
        </Box>
      </Container>
    </Box>
  );
}

export default WorkspaceListLayout;
